import { Button, CircularProgress } from "@mui/material";
import React from "react";

const CustomLoader = (props) => {
    const {type,onSubmit,btnTitle,loading, sx={},disabled,circleSx={}} = props
  return (
    <>
      <Button
        sx={{
          width: "100%",
          borderRadius: "15px",
          background: "white",
          padding: "8px 12px",
          fontWeight: "400",
          fontSize: "18px",
          color: "black",
          textTransform: "capitalize",
          "&:hover": {
            background: "white",
            color: "black",
          },
          ...sx
        }}
        disabled={disabled}
        type={type}
        onClick={onSubmit}
      >
        {loading ? (
          <CircularProgress
            size={32}
            sx={{
              color: "#C6FF00",
              ...circleSx
            }}
          />
        ) : (
          btnTitle
        )}
      </Button>
    </>
  );
};

export default CustomLoader;
